import Layout from '@/layout/default.vue'

const guideRouter = {
  path: '/guide',
  name: 'guide',
  component: Layout,
  children: [
    {
      path: 'auth',
      name: 'guide-account-auth',
      meta: {
        title: '账号认证',
        isShowHeader: true,
        isShowNav: true
      },
      component: () => import('@/views/guide/account_auth.vue')
    },
    {
      path: 'initiator',
      name: 'guide-initiator',
      meta: {
        title: '发起人指引',
        isShowHeader: true,
        isShowNav: true
      },
      component: () => import('@/views/guide/initiator_guide.vue')
    },
    {
      path: 'index',
      name: 'guide-operation',
      meta: {
        title: '众筹运营指引',
        isShowHeader: true,
        isShowNav: true
      },
      component: () => import('@/views/guide/operation_guide.vue')
    },
    {
      path: ':slug',
      name: 'guide-detail',
      meta: {
        title: '用户指引',
        isShowHeader: true,
        isShowNav: true
      },
      component: () => import('@/views/guide/index.vue')
    },
    {
      path: 'open_wxxcx',
      name: 'guide-open-wxxcx',
      meta: {
        title: '打开小程序',
        isShowHeader: true,
        isShowNav: true
      },
      component: () => import('@/views/guide/open_wxxcx.vue')
    }
  ]
}

export default guideRouter 